import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios, blobToBase64 } from '../../utils/axios';
import { jDate } from '../../utils/formatTime';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const startDate = new Date();
startDate.setMonth(0, 1);

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  params: {
    account_id: '',
    entries_state: 'all',
    start_date: jDate(startDate),
    end_date: jDate(new Date()),
  },
};

const slice = createSlice({
  name: 'accountStatement',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET accountStatement
    getAccountStatementSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams } = slice.actions;

// ----------------------------------------------------------------------

export function getAccountStatement(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/accounts/statement/', {
        params,
      });
      dispatch(slice.actions.getAccountStatementSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function printAccountStatement(params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/accounts/account-statement-print`, { params, responseType: 'blob' });
      if (window.isNativeApp) return await blobToBase64(response.data);
      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error(error);
      return error;
    }
  };
}
